<template>
  <div class="activation" v-loading="loading">
    <div class="status-img">
      <img class="img" v-if="status === 'success'" src="../../assets/img/success.png">
      <img class="img" v-if="status === 'fail'" src="../../assets/img/fail.png">
    </div>
    <div class="status-text">{{statusText}}</div>
    <div v-if="status === 'success'" class="status-content">
      <div class="login">
        打开
        <a v-if="localHost === 'dev'" class="grey-a" target="_blank" href="http://account.zmcms.cn">http://account.zmcms.cn</a>
        <a v-if="localHost === 'test'" class="grey-a" target="_blank" href="https://account.qimai.shop">https://account.qimai.shop</a>
        <a v-if="localHost === 'release'" class="grey-a" target="_blank" href="https://account.qmai.co">https://account.qmai.co</a>
        <a v-if="localHost === 'master'" class="grey-a" target="_blank" href="https://account.qmai.cn">https://account.qmai.cn</a>
        登录后可管理门店
      </div>
      <div v-if="status === 'success'" class="form">
        账户：{{form.name}}<br>
        密码：{{form.password}}
      </div>
      <div v-if="status === 'success'" class="tips">
        <img class="tips-icon" src="https://img-shop.qmimg.cn/s16/images/2019/12/25/20d8da25b6ae375c.png" >
        <div class="tips-text">温馨提示：离开页面前，请及时备份账户密码，为了您的信息安全下次访问将不再展示</div>
      </div>
    </div>
    <div v-if="status === 'fail'" class="status-content">
      <div class="form">
        激活链接已失效或其他问题<br>
        请联系店铺管理员
      </div>
    </div>
    <div class="logo-triangle"></div>
    <div class="logo"></div>
    <img class="logo-img" src="../../assets/img/logo.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data () {
    return {
      loading: true,
      status: 'wait', // 状态
      statusText: '',
      form: {
        name: '', // 账户
        password: '' // 密码
      }
    }
  },
  computed: {
    // 当前环境
    localHost () {
      let host = location.host
      let type = 'dev'
      if (host === 'account.zmcms.cn') type = 'dev'
      if (host === 'account.qimai.shop') type = 'test'
      if (host === 'account.qmai.co') type = 'release'
      if (host === 'account.qmai.cn') type = 'master'
      return type
    }
  },
  methods: {
    // 获取激活信息
    _getInfo () {
      this.loading = true
      let that = this
      document.querySelector('html').className = 'activation'
      QM.apinew({
        url: '/seller/account/activate',
        method: 'POST',
        data: {
          ek: that.$route.params.id
        },
        success: function (xdata) {
          if (xdata.data.expired === false && xdata.data.activated === true) {
            that.status = 'success'
            that.statusText = '激活成功'
            that.form.name = xdata.data.username
            that.form.password = xdata.data.password
            that.loading = false
          } else {
            that.status = 'fail'
            that.statusText = '激活失败'
            that.loading = false
          }
        },
        error: function (xdata) {
          that.loading = false
          that.$message({
            message: xdata.message,
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this._getInfo()
  }
}
</script>

<style scoped>
.activation {
  text-align: center;
  width: 100%;
  height: 100%;
  padding-top: 25vh;
}
.status-img {
  width: 18.3%;
  height: auto;
  margin: 0 auto;
  max-width: 90px;
  max-height: 90px;
}
.status-img .img {
  width: 100%;
}
.grey-a {
  color: rgba(0,0,0,1);
}
.status-text {
  font-size: 1.2rem;
  font-family: 'PingFang-SC-Bold';
  font-weight: bold;
  color: rgba(0,0,0,1);
  margin-top: 2vh;
}
.status-content {
  text-align: center;
  font-size: 0.8rem;
  font-family: 'PingFang-SC-Medium';
  font-weight: 500;
  color: rgba(51,51,51,1);
}
.login {
  margin-top: 3vh;
  font-size: 0.8rem;
}
.form {
  margin-top: 1.5vh;
  font-size: 0.8rem;
  line-height: 22px;
}
.logo-triangle {
  position: absolute;
  bottom: 15vh;
  height: 20vh;
  width: 100vw;
  left: 0;
}
.logo-triangle:after {
  content: "";
  position: fixed;
  bottom: 15vh;
  width: 100vw;
  z-index: -1;
  height: 20vh;
  left: 0;
  border-left: 100vw solid transparent;
  border-bottom: 20vh solid #f7f9f7;
}
.logo {
  position: fixed;
  z-index: -2;
  background-color: #f7f9f7;
  bottom: 0;
  left: 0;
  height: 15vh;
  width: 100vw;
}
.logo-img {
  position: fixed;
  bottom: 6vh;
  z-index: 2;
  width: 40.3%;
  height: auto;
  margin: 0 auto;
  left: 0;
  right: 0;
  max-width: 200px;
}

.tips {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tips-icon {
  height: 40rpx;
  width: 40rpx;
}

.tips-text {
  font-size: 14px;
  color: #666666;
}
</style>